import { interpret } from '@fingermarkglobal/utilities';
import { validate } from '@fingermarkglobal/validation';
import { refundMachine as machine } from './machine';

const refund = ({
  amount = null,
  transactionId = null,
  timestamp = null,
  config = null,
  transition = null,
} = {}) => {
  validate({ name: 'Mock Refund', paramaters: { amount, transactionId, timestamp, config } });

  const { instance: refundMachine } = interpret({
    name: 'refundMachine',
    machine,
    transition,
  });

  refundMachine.send('INITIALISE', { amount, transactionId, timestamp, config });

  return { refundMachine };
};

export { refund };
